// import { AsciiEffect } from '../modules/0xAsciiEffect.js';
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';

const easeOutQuad = t => t * ( 2 - t );
const easeOutExpo = t => t === 1 ? 1 : 1 - Math.pow(2, -10 * t);

// const ASCIICHARACTERS = ' .\'`^*",/;~+_-}{1)(|0#';
// const ASCIICHARACTERS = ' .:-+*=%☺@#'

export default class expertAscii {
  constructor(){
    this.ASCIICHARACTERS = $('#asciiLetters').val();


    this.start = null;

    this.doIntro = true;
    this.range = 0.25;
    this.speed = 0.0001;

    // this.newEffect = AsciiEffect;

    this.image = undefined;
    this.camera = undefined;
    this.controls = undefined;
    this.scene = undefined;
    this.renderer = undefined;
    this.effect = undefined;

    this.pointLight1 = undefined;
    this.pointLight2 = undefined;

    this.sphere = undefined;
    this.plane = undefined;
    this.image = undefined;
    this.sprite = undefined;

    // var shader = new AsciiShader();
    var uniforms = {
      time: {
        type: "f",
        value: 1.0
      },
      resolution: {
        type: "v2",
        value: new THREE.Vector2()
      },
      charsize : {
        type: "f",
        value: 4.0,
      },
      brightness : {
        type: "f",
        value: MOBSIZE ? 0.2 : 0.33,
      }
    };
    uniforms.resolution.value.x = MOBSIZE ? window.innerWidth * 1.09 : window.innerWidth;
    uniforms.resolution.value.y = MOBSIZE ? window.innerHeight * 1.09 : window.innerHeight;
    
    this.shaderMaterial = new THREE.ShaderMaterial({
      uniforms: uniforms,
      vertexShader: document.getElementById('asc-general').textContent,
      fragmentShader: document.getElementById('asc-frag1').textContent
    });
    this.clock = new THREE.Clock();

    this.ORIGSPRITESCALE = MOBSIZE ? 15 : 30;

    this.init = this.init.bind(this);
    this.binds = this.binds.bind(this);
    this.animate = this.animate.bind(this);
    this.render = this.render.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);

    this.init();
    this.binds();
    this.animate();

    window.rend = this;

  }

  binds() {
    var parent = this;
    $('#asciiLetters').on('input keyup', function(){
      if($(this).val().indexOf(' ')!==0){
        $(this).val('  '+$(this).val());
      }
      let v = $(this).val();
      parent.ASCIICHARACTERS = v;
      parent.effect.aCharList = v;
    });

    $('#range').on('mousemove input', function(){
      let prc = $(this).val()/100;
      window.expertAscii.range = prc;
    });

    $('#speed').on('mousemove input', function(){
      let prc = $(this).val()/100000;
      window.expertAscii.speed = prc;
    });
  }

  init() {
    let camera = this.camera;
    let controls = this.controls;
    let scene = this.scene;
    let renderer = this.renderer;
    let effect = this.effect;

    let sphere = this.sphere;
    let plane = this.plane;
    let image = this.image;
    let sprite = this.sprite;

    let pointLight1 = this.pointLight1;
    let pointLight2 = this.pointLight2;

    this.camera = new THREE.PerspectiveCamera( 10, window.innerWidth / window.innerHeight, 1, 5000 );
    this.camera.position.y = 0;
    this.camera.position.z = 500;

    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color( 0, 0, 0 );

    this.pointLight1 = new THREE.PointLight( 0xffffff, 0.0);
    this.pointLight1.position.set( 400, 400, 400 );
    this.scene.add( this.pointLight1 );

    this.pointLight2 = new THREE.PointLight( 0xffffff, 0.0);
    this.pointLight2.position.set( -500, -500, -500 );
    this.scene.add( this.pointLight2 );

    this.renderer = new THREE.WebGLRenderer({
      'antialias' : true,
      powerPreference: "low-power",
    });
    this.renderer.setPixelRatio( 1 );

    this.renderer.setSize( MOBSIZE ? window.innerWidth*1.09 : window.innerWidth, MOBSIZE ? window.innerHeight * 1.09 : window.innerHeight );
    this.renderer.shadowMap.enabled = true;

    this.composer = new EffectComposer( this.renderer );
    this.composer.addPass( new RenderPass( this.scene, this.camera ) );
    this.composer.setSize( MOBSIZE ? window.innerWidth*1.09 : window.innerWidth, MOBSIZE ? window.innerHeight * 1.09 : window.innerHeight );

    this.asciiPass = new ShaderPass(this.shaderMaterial, "media");
    this.shaderMaterial.uniforms.media = this.composer.renderTarget1;
    this.composer.addPass( this.asciiPass );

    // this.effect = new AsciiEffect( this.renderer, this.ASCIICHARACTERS, {
    //   invert: true,
    //   resolution: MOBSIZE ? 0.28 : .25,
    // } );
    // this.effect.setSize( MOBSIZE ? window.innerWidth*1.09 : window.innerWidth, MOBSIZE ? window.innerHeight * 1.09 : window.innerHeight );
    // this.effect.domElement.style.color = 'white';
    var addTo = $('.expert-ascii-photo').get(0);
    this.renderer.domElement.className = 'ascii-expert';
    // this.effect.domElement.className = 'ascii-expert';
    // addTo.appendChild( this.effect.domElement );
    addTo.appendChild( this.renderer.domElement );

    // this.controls = new TrackballControls( this.camera, this.effect.domElement );

    const material = new THREE.MeshPhongMaterial( { color: 0xAAAAAA, specular: 0x111111, shininess: 200 } );
    const loader = new THREE.TextureLoader();
    const LOADURL = $('.expert-photo').attr('data-square');


    const intersectorGeometry = new THREE.PlaneGeometry( 1000, 1000 );
    const intersectorMaterial = new THREE.MeshBasicMaterial( {
      color: 0xffffff,
      visible: false,
    });

    var intersector = new THREE.Mesh( intersectorGeometry, intersectorMaterial );


    var parent = this;

    loader.load( LOADURL, function ( texture ) {

      parent.start = Date.now();

      // let sz = window.innerHeight<window.innerWidth ? window.innerWidth * .1 : window.innerHeight * .12;
      let szMultip = .08;
      let sz = window.innerHeight < window.innerWidth ? window.innerHeight * szMultip : window.innerWidth * szMultip;

      if(window.innerHeight < 900) {
        sz = window.innerHeight * szMultip * 1.25;
      }
      if(window.innerHeight < 800) {
        sz = window.innerHeight * szMultip * 1.33;
      }

      if(MOBSIZE) {
        sz = window.innerWidth * .2;
      }

      const geometry = new THREE.PlaneGeometry( parseInt(sz), parseInt(sz) );
      const material = new THREE.MeshBasicMaterial( {
        color: 0xffffff,
        map: texture,
        side: THREE.DoubleSide
      } );

      parent.image = new THREE.Mesh( geometry, material );

      parent.image.name = 'image';

      parent.image.position.y = 0;
      parent.image.position.z = -2000;

      console.log('image done',image);

      parent.scene.add( parent.image );
        // this.image = image;

        parent.renderer.domElement.classList += ' show';

      });

    const spriteMap = new THREE.TextureLoader().load( siteurl+'/assets/i/fadeSpriteLess.png' );
    const spriteMaterial = new THREE.SpriteMaterial( { map: spriteMap } );

    this.sprite = new THREE.Sprite( spriteMaterial );
    this.sprite.scale.set(this.ORIGSPRITESCALE, this.ORIGSPRITESCALE, this.ORIGSPRITESCALE)
    this.sprite.position.x = 9999;
    this.sprite.position.y = 9999;
    this.sprite.position.z = 50;
    this.scene.add( this.sprite );

    window.addEventListener( 'resize', this.onWindowResize );

    var raycaster = new THREE.Raycaster();

    $(document).bind( 'mousemove touchmove', function(event){
        // console.log(event);
        let posX = event.originalEvent.clientX;
        let posY = event.originalEvent.clientY;

        if(event.type == 'touchmove'){
          console.log('touchmove!');
          event = event.touches[0];
          posX = event.clientX;
          posY = event.clientY;
        }

        if(parent.image) {
          let x = (posX / parent.renderer.domElement.clientWidth ) * 2 - 1;
          let y = - ( posY / parent.renderer.domElement.clientHeight ) * 2 + 1;

          let threePos = new THREE.Vector3(x,y,0);

          raycaster.setFromCamera( threePos, parent.camera );
          var intersects = raycaster.intersectObject( intersector );
          if ( intersects.length > 0 ) {
            var point = intersects[ 0 ].point;
            parent.sprite.position.set(point.x, point.y, 20);
          }
        }
      });

  }


  onWindowResize() {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize( MOBSIZE ? window.innerWidth*1.09 : window.innerWidth, MOBSIZE ? window.innerHeight * 1.09 : window.innerHeight );
    this.composer.setSize( MOBSIZE ? window.innerWidth*1.09 : window.innerWidth, MOBSIZE ? window.innerHeight * 1.09 : window.innerHeight );

    this.shaderMaterial.uniforms.resolution.value.x = MOBSIZE ? window.innerWidth*1.09 : window.innerWidth;
    this.shaderMaterial.uniforms.resolution.value.y = MOBSIZE ? window.innerHeight * 1.09 : window.innerHeight;
    
  }

  animate() {
    window.introRaf = requestAnimationFrame( this.animate );
    if(this.shaderMaterial){
      this.shaderMaterial.uniforms.time.value = this.clock.getElapsedTime();
    }
    this.render();
  }

  render() {
    const timer = Date.now() - this.start;
    let positionDuration = 1500;

    if(this.image) {
      const progressPosQuad = easeOutQuad( Math.min(positionDuration, timer) / positionDuration );
      let progressPos = easeOutExpo( Math.min(positionDuration, timer) / positionDuration );
      if(progressPos < 1.0 ) {
        this.image.position.z = 500 - (500*progressPos) + 10;
        this.image.rotation.x = -Math.PI * this.range + ((Math.PI * this.range)*progressPos);
      }

      if(!MOBSIZE) {
        this.image.rotation.x = -Math.PI * this.range + ((Math.PI * this.range)*progressPos);
        this.image.rotation.x += Math.sin(timer*this.speed) * this.range;
      } else {
        this.image.position.y = 6;
      }
      this.image.rotation.y = Math.sin(timer*this.speed*2) * this.range;

      // if(!MOBSIZE) {
      if(MOBSIZE && progressPos<1) {
        progressPos -= 0.2;
        $('.expert-ascii-photo').css({
          'opacity': progressPos
        });
      } else if(!MOBSIZE) {
        $('.expert-ascii-photo').css({
          'opacity': progressPos
        });
      }
    }

    if(this.sprite){
      var spriteScale = this.ORIGSPRITESCALE + (Math.sin(timer*0.001) * 5);
      this.sprite.scale.set(spriteScale, spriteScale, spriteScale)
    }

    // this.controls.update();
    this.renderer.render( this.scene, this.camera );
    this.composer.render( this.scene, this.camera );
    // this.effect.render( this.scene, this.camera );
  }
}
